<template>
  <div class="page-card">
    <div class="page-card__head">
      <div>
        <div class="page-card__title">环境记录</div>
        <div class="page-card__desc">查看环境数据和设备状态，后续可接告警、巡检和清洁计划。</div>
      </div>
      <button class="action-button">新增记录</button>
    </div>

    <div class="placeholder-grid">
      <div class="placeholder-card">环境日志</div>
      <div class="placeholder-card">设备状态</div>
      <div class="placeholder-card">告警中心</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnvironmentRecordView"
}
</script>
